import PropTypes from 'prop-types'
import React     from 'react'
import { Alert } from 'react-bootstrap'

import { WithCardLogin } from 'alto-react-canteen/lib/components'

import LoggedInMenu  from './logged_in_menu'
import LoggedOutMenu from './logged_out_menu'

import './main.sass'

export default class Menu extends React.Component
  @contextTypes = { auth: PropTypes.object }

  render: ->
    content =
      if @context.auth.isLoggedIn
        if @context.auth.isClient
          <LoggedInMenu />
        else
          <Alert bsStyle='danger'>Toto není klientský účet</Alert>
      else
        <WithCardLogin action='objednání'>
          <LoggedOutMenu />
        </WithCardLogin>

    <div id="menu">{content}</div>
